import { useTranslation } from 'react-i18next';
import { LuX } from 'react-icons/lu';

import useDemandedDocuments from '~/features/leadDetails/hooks/useDemandedDocuments';
import type { SchemaDemandedDocumentsKeys } from '~/features/leadDetails/schemas/demandedDocuments.schema';

export const SelectedDocuments: React.FC = () => {
    const { t } = useTranslation();
    const { demandedDocuments, updateDemandDocument } = useDemandedDocuments();

    const selected = Object.entries(demandedDocuments).flatMap(([path, entries]) =>
        entries.filter(({ requested }) => requested).map(({ name }) => ({ name, path })),
    );

    if (selected.length === 0) return null;

    return (
        <div>
            <p className="mb-2 text-sm font-medium text-midnight">
                {t('DOCUMENT_DEMANDER.PREVIEW.SELECTED_DOCUMENTS')}
            </p>
            <div className="flex flex-wrap gap-2">
                {selected.map(({ name, path }) => (
                    <span
                        key={`${path}-${name}`}
                        className="inline-flex items-center gap-2 px-3 py-1.5 text-sm bg-white border rounded-full border-grey-outline-light text-midnight"
                    >
                        {name}
                        <button
                            aria-label={t('DOCUMENT_DEMANDER.PREVIEW.REMOVE_DOCUMENT', { name })}
                            onClick={() => updateDemandDocument(path as SchemaDemandedDocumentsKeys, name, false)}
                            type="button"
                        >
                            <LuX size={14} />
                        </button>
                    </span>
                ))}
            </div>
        </div>
    );
};
